// import Plyr from 'plyr/dist/plyr.js';
// import Plyr from 'plyr';
import Plyr from '../libs/plyr';

// import {CLASSES} from '../helpers/consts';

const initPlayer = (el) => {

	return new Plyr(el, {
		controls: ['play-large', 'play', 'progress', 'mute', 'volume', 'fullscreen'],
		ratio: '16:9',
		muted: false,
		// loop: true,
		autoplay: false,
	});
};

const initVideo = (el, block) => {
	const sourceEl = el.querySelector('source');
	const dataSrc = sourceEl.getAttribute('data-src');
	console.log(dataSrc);

	sourceEl.src = dataSrc;
	el.load();

	const player = initPlayer(el);
	player.on('play', event => {
		event.target.classList.add('is-active');
	});

	const poster = block.querySelector('.js-large-media-video-block-poster');
	poster.onclick = () => {
		console.log(poster)
		player.play();
		block.classList.add('is-video-view');
	};

};

export default () => {
	const videos = document.querySelectorAll('.js-large-media-video-block');
	videos.forEach(block => {
		const video = block.querySelector('.js-large-media-video');
		
		if(video)	initVideo(video, block);
	});
}